import * as React from 'react';
import { deepCompare } from '@agilepoint/utils-common';
import { IntervalTimer } from '../utils/timer';
import { currentWindow } from '../utils/env';
// import { IntervalTimer } from '../utils/timer';

function getBoundingRect(el: HTMLElement | null) {
    return el ? el.getBoundingClientRect() as ClientRect : { left: 0, right: 0, top: 0, bottom: 0 } as ClientRect;
}

export const useBoundingRect = (ref: React.RefObject<HTMLElement>) => {
    const [clientRect, setClientRect] = React.useState(getBoundingRect(ref.current));

    const handleResize = React.useCallback(() => {
        const currentRect = getBoundingRect(ref.current);
        if (deepCompare(currentRect, clientRect)) {
            return;
        }
        setClientRect(currentRect);
    }, [clientRect, ref]);

    const hasResizeObserver = typeof (currentWindow as any).ResizeObserver === 'function';

    React.useLayoutEffect(() => {
        if (!ref.current) {
            return;
        }

        const refElement = ref.current;

        if (hasResizeObserver) {
            let resizeObserver = new (currentWindow as any).ResizeObserver(() => handleResize());
            resizeObserver.observe(refElement);
            handleResize();
            return () => {
                resizeObserver.disconnect(refElement);
                resizeObserver = null;
            };
        }

        currentWindow.addEventListener('resize', handleResize);
        return () => {
            currentWindow.removeEventListener('resize', handleResize);
        };
    }, [handleResize, hasResizeObserver, ref]);

    React.useLayoutEffect(() => {
        if (!hasResizeObserver) {
            handleResize();
            const timer = new IntervalTimer(handleResize);
            timer.start(5000);
            return () => {
                timer.stop();
            };
        }
        return undefined;
    }, [handleResize, hasResizeObserver]);

    return clientRect;
};
